// extracted by mini-css-extract-plugin
module.exports = {"text_color_white":"CoverImageControlContents_text_color_white__FW0M8"};